module.exports = __webpack_public_path__ + "img/codi.4ac0253.png";